export const ATTRIBUTION_MEDIA_SOURCE_NAMES = [
  'utm_source',
  'media_source',
  'pid',
]

export const ATTRIBUTION_CAMPAIGN_NAMES = ['utm_campaign', 'c']
